// // need to uncomment the following after abtest done
// setTimeout(() => {
//   const hasBottomSheetDisplayed = sessionStorage.getItem('popupDisplayed');
//   if (!hasBottomSheetDisplayed) {
//     document.body.classList.add('dev_acb-bottomsheet-open');
//     if (typeof gaEvent === 'function') {
//       gaEvent('ACB_popup', ["", "", "", "", "", ""], false);
//     }
//     sessionStorage.setItem('popupDisplayed', true);
//   }
// }, 1000);

// function getCookie(name) {
//    const nameEQ = name + "=";
//    const ca = document.cookie.split(';');
//    for (let i = 0; i < ca.length; i++) {
//       let c = ca[i].trim();
//       if (c.indexOf(nameEQ) === 0) {
//          return decodeURIComponent(c.substring(nameEQ.length));
//       }
//    }
//    return null;
// }


// function setLeadSubmittedFlag() {
//    const days = 30;
//    const date = new Date();
//    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

//    // set cookie with path and SameSite for reliability
//    document.cookie = "leadSubmitted=true; expires=" + date.toUTCString() + "; path=/; SameSite=Lax";
// }


// function shouldShowCallbackPopup() {
//    const exists = getCookie("leadSubmitted");
//    return !exists; // show popup if cookie not found
// }


// function showCallbackPopup() {
//    const popup = document.getElementById("callback-modal");
//    if (popup) {
//       document.body.classList.add('dev_acb-bottomsheet-open');
//       //popup.style.display = "block";

//       // fire GA event
//       if (typeof gaEvent === 'function') {
//          gaEvent("ACB_popup", ["", "", "", "", "", ""], false);
//       }
//    }
// }


// // condition: only show popup if cookie not set
// if (shouldShowCallbackPopup()) {
//    setTimeout(() => {
//       showCallbackPopup();
//    }, 1000); // Delay popup
// }


// // attach listeners to multiple buttons
// const buttons = [
//    "#contact-form #arrangecallback_submitmain.acbcusmodal-submit",
//    ".bottomsheet-callback__form #dev_bottomsheet-callback-submit.bottomsheet-callback__button"
// ];


// buttons.forEach(selector => {
//    const btn = document.querySelector(selector);
//    if (btn) {
//       btn.addEventListener("click", function () {
//          console.log("📩 Button clicked, setting cookie");
//          setLeadSubmittedFlag();
//       });
//    } else {
//       console.log(`⚠️ Button not found: ${selector}`);
//    }
// });

const bottomSheetUrlParams = new URLSearchParams(window.location.search);
const bottomSheetUtmSource = bottomSheetUrlParams.get('utm_source') || '';
const bottomSheetUtmCampaign = bottomSheetUrlParams.get('utm_campaign') || '';
const bottomSheetIsPaid = bottomSheetUrlParams.has('utm_source') && bottomSheetUrlParams.has('utm_campaign');

if (document.getElementById('PMOO')) {
  document.getElementById('PMOO').value = bottomSheetIsPaid ? 'PM' : 'Organic';
}
if (document.getElementById('UTMSOURCE')) {
  document.getElementById('UTMSOURCE').value = bottomSheetUtmSource;
}
if (document.getElementById('UTMCAMPS')) {
  document.getElementById('UTMCAMPS').value = bottomSheetUtmCampaign;
}

const bottomSheetCloseButton = document.getElementById('dev_bottomsheet-callback__close');
const bottomSheetOverlay = document.querySelector('.bottomsheet-callback__overlay');
const bottomSheetForm = document.getElementById('callback-form');
const bottomSheetContent = document.getElementById('dev_bottomsheet-callback__content');
const bottomSheetKeepBrowsingButton = document.getElementById('dev_bottomsheet-callback-keepbrowsing__button');
const bottomSheetCallbackPhone = document.getElementById('dev_bottomsheet-callback-phone');
const bottomSheetCallbackPincode = document.getElementById('dev_bottomsheet-callback-pincode');
const bottomSheetSubmitButton = document.getElementById('dev_bottomsheet-callback-submit');

const originalPlaceholderPhone = bottomSheetCallbackPhone.placeholder;
const originalPlaceholderPincode = bottomSheetCallbackPincode.placeholder;

const bottomSheetCallbackPhoneError = document.getElementById('dev_bottomsheet-callback-phone-error');
const bottomSheetCallbackPincodeError = document.getElementById('dev_bottomsheet-callback-pincode-error');

if (bottomSheetKeepBrowsingButton) {
  bottomSheetKeepBrowsingButton.addEventListener('click', closeBottomSheet);
}
if (bottomSheetCloseButton) {
  bottomSheetCloseButton.addEventListener('click', closeBottomSheet);
}
if (bottomSheetOverlay) {
  bottomSheetOverlay.addEventListener('click', closeBottomSheet);
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape' && document.body.classList.contains('dev_acb-bottomsheet-open')) {
    closeBottomSheet();
  }
});

function checkFormValidity() {
  if (!bottomSheetCallbackPhone || !bottomSheetCallbackPincode || !bottomSheetSubmitButton) return;
  
  const bottomSheetPhone = bottomSheetCallbackPhone.value.trim();
  const bottomSheetPincode = bottomSheetCallbackPincode.value.trim();
  
  const bottomSheetIsPhoneValid = isValidPhone(bottomSheetPhone);
  const bottomSheetIsPincodeValid = isValidPincode(bottomSheetPincode);
  
  bottomSheetSubmitButton.disabled = !(bottomSheetIsPhoneValid && bottomSheetIsPincodeValid);
  console.log('validated2',bottomSheetIsPhoneValid,bottomSheetIsPincodeValid);
  if(bottomSheetPhone != ''){
      bottomSheetCallbackPhoneError.innerHTML = '';
      bottomSheetCallbackPhone.classList.remove('dev_bottomsheet-input-invalid');
  }
  if(bottomSheetPincode != ''){
      bottomSheetCallbackPincodeError.innerHTML = '';
      bottomSheetCallbackPincode.classList.remove('dev_bottomsheet-input-invalid');
  }
  if(bottomSheetPhone != '' && bottomSheetPincode != ''){
    bottomSheetSubmitButton.disabled = false;
  }
  
}

if (bottomSheetCallbackPhone) {
  bottomSheetCallbackPhone.addEventListener('input', checkFormValidity);
  bottomSheetCallbackPhone?.addEventListener('focus', function(e) {
    bottomSheetCallbackPhone.placeholder = "";
  });
  bottomSheetCallbackPhone?.addEventListener('blur', function(e) {
    bottomSheetCallbackPhone.placeholder = originalPlaceholderPhone;
  });
}

if (bottomSheetCallbackPincode) {
  bottomSheetCallbackPincode.addEventListener('input', checkFormValidity);
  bottomSheetCallbackPincode?.addEventListener('focus', function(e) {
    bottomSheetCallbackPincode.placeholder = "";
  });
  bottomSheetCallbackPincode?.addEventListener('blur', function(e) {
    bottomSheetCallbackPincode.placeholder = originalPlaceholderPincode;
  });
}

if (bottomSheetForm) {
  bottomSheetSubmitButton?.addEventListener('click', function(e) {
    if(bottomSheetCallbackPhone.value == '' && bottomSheetCallbackPincode.value == ''){
      bottomSheetCallbackPhoneError.innerHTML = 'Contact No. is required';
      bottomSheetCallbackPincodeError.innerHTML = 'Pincode is required';
      bottomSheetSubmitButton.disabled = true;
      bottomSheetCallbackPhone.classList.add('dev_bottomsheet-input-invalid');
      bottomSheetCallbackPincode.classList.add('dev_bottomsheet-input-invalid');
    }
  });


  bottomSheetForm.addEventListener('submit', function(e) {
    e.preventDefault();
    
    const bottomSheetPhone = bottomSheetCallbackPhone ? bottomSheetCallbackPhone.value.trim() : '';
    const bottomSheetPincode = bottomSheetCallbackPincode ? bottomSheetCallbackPincode.value.trim() : '';
    
    if(bottomSheetPhone.length < 10 && bottomSheetPhone.length != 0){
      bottomSheetCallbackPhoneError.innerHTML = 'Contact No. must be a 10 digit number';
      bottomSheetCallbackPhone.classList.add('dev_bottomsheet-input-invalid');
    } else if(bottomSheetPhone.length == 0){
      bottomSheetCallbackPhoneError.innerHTML = '';
      bottomSheetCallbackPhone.classList.remove('dev_bottomsheet-input-invalid');
    } else if(!isValidPhone(bottomSheetPhone)){
      bottomSheetCallbackPhoneError.innerHTML = 'Contact No. must be valid';
      bottomSheetCallbackPhone.classList.add('dev_bottomsheet-input-invalid');
    } 

    if(bottomSheetPincode.length < 6 && bottomSheetPincode.length != 0){
      bottomSheetCallbackPincodeError.innerHTML = 'Pincode must be at least 6 characters';
      bottomSheetCallbackPincode.classList.add('dev_bottomsheet-input-invalid');
    } else if(bottomSheetPincode.length == 0) {
      bottomSheetCallbackPincodeError.innerHTML = '';
      bottomSheetCallbackPincode.classList.remove('dev_bottomsheet-input-invalid');
    } else if(!isValidPincode(bottomSheetPincode)){
      bottomSheetCallbackPincodeError.innerHTML = 'Pincode must be valid';
      bottomSheetCallbackPincode.classList.add('dev_bottomsheet-input-invalid');
    } 

    if (isValidPhone(bottomSheetPhone) && isValidPincode(bottomSheetPincode)) {
      submitLead(bottomSheetPhone, bottomSheetPincode);
      setLeadSubmittedFlag();
      showConfirmedBottomSheet();
    }
    gaEvent('notify_me_OOS_submit', ['', '', bottomSheetPhone, bottomSheetPincode, '', ''], false);
  });
}

function isValidPhone(phone) {
  return phone.length === 10 && /^[6-9]\d{9}$/.test(phone);
}

function isValidPincode(pincode) {
  return pincode.length === 6 && /^\d{6}$/.test(pincode) && pincode !== "123456";
}

function closeBottomSheet() {
  document.body.classList.remove('dev_acb-bottomsheet-open');
  if (typeof gaEvent === 'function') {
    gaEvent('acb_cancelled', ["", "", "", "", "", ""], false);
  }
  localStorage.setItem('callbackbottomSheetIsExisting', 'true');
}

function showConfirmedBottomSheet() {
  if (bottomSheetContent) {
    bottomSheetContent.classList.add('dev_open-bottomsheet-callback__confirmed');
  }
}

function getProductInfo() {
  const bottomSheetProductType = document.getElementById('dev_bottomsheet-callback-product-type');
  const bottomSheetProductTitle = document.getElementById('dev_bottomsheet-callback-product-title');
  
  let bottomSheetCategory = bottomSheetProductType ? bottomSheetProductType.value : '';
  let bottomSheetTitle = bottomSheetProductTitle ? bottomSheetProductTitle.value : '';
  
  if (!bottomSheetCategory || !bottomSheetTitle) {
    const bottomSheetUrlPath = window.location.pathname;
    const bottomSheetPathSegments = bottomSheetUrlPath.split('/').filter(Boolean);
    
    let bottomSheetFallback = bottomSheetPathSegments.length ? bottomSheetPathSegments[bottomSheetPathSegments.length - 1] : 'homepage';
    
    if (bottomSheetPathSegments.length === 1 && bottomSheetPathSegments[0] === 'thesleepcompany.in') {
      bottomSheetFallback = 'homepage';
    }
    
    if (!bottomSheetCategory) bottomSheetCategory = bottomSheetFallback;
    if (!bottomSheetTitle) bottomSheetTitle = bottomSheetFallback;
  }
  
  return { category: bottomSheetCategory, title: bottomSheetTitle };
}

function submitLead(phone, pincode) {
  const bottomSheetPageUrl = window.location.href;
  const bottomSheetProductInfo = getProductInfo();

  const bottomSheetExistingCallbackValue = localStorage.getItem('callbackbottomSheetIsExisting');
  const bottomSheetIsExisting = bottomSheetExistingCallbackValue === 'true';
  
  const bottomSheetFormData = {
    "phone": phone,
    "source": bottomSheetIsExisting ? "Arrange Call Back - Repeat Visit" : "Arrange Call Back",
    "page_url": bottomSheetPageUrl,
    "pincode": pincode,
    "activity_note": pincode,
    "activity_source": bottomSheetIsExisting ? "Arrange Call Back - Repeat Visit" : "Arrange Call Back",
    "lead_status": "Tier 2",
    "mx_custom_4": bottomSheetProductInfo.category,
    "mx_custom_7": bottomSheetUtmCampaign,
    "mx_custom_8": bottomSheetUtmSource,
    "mx_custom_36": getDeviceModel(),
    "mx_custom_35":  getOSWithVersion(),
    "source_page": bottomSheetPageUrl,
    "product_type": bottomSheetProductInfo.category,
    "is_web_engage_event": true,
    "web_engage_data": {
      "product_category": bottomSheetProductInfo.category,
      "product_subcategory": bottomSheetProductInfo.title,
      "product_page": bottomSheetPageUrl,
      "pincode": pincode
    },
    "web_engage_user_data": {
      "category": bottomSheetProductInfo.category,
      "subcategory": bottomSheetProductInfo.title
    }
  };
  
  fetch('https://apis.thesleepcompany.in/lead/datafeed', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(bottomSheetFormData)
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network error');
    }
    return response.json();
  })
  .then(() => {
    if (typeof dataLayer !== 'undefined') {
      dataLayer.push({
        event: 'Arrange_a_callback',
        custom: { param_1: "", param_2: "", param_3: null, param_4: phone }
      });
      
      dataLayer.push({ custom: null });
      
      dataLayer.push({
        event: "form2",
        custom: { param_1: "", param_2: "", param_3: null, param_4: phone }
      });

      localStorage.setItem('callbackbottomSheetIsExisting', 'true');
      localStorage.setItem("ACBpopup_number",bottomSheetFormData.phone);
    }
  })
  .catch(error => {
    console.error('Error submitting lead:', error);
  });
}

window.nitroSettings = {
  ready: function (token, parent, nitro_id) {
    fetch(`https://apis.thesleepcompany.in/utilities/nitro/contact-details/4777f2d5-6c95-4c4e-bf77-b638708c5b15/557ddac8-0947-442f-9a87-ac969d621449`, {
      method: "GET",
      headers: {
        "Cookie": "_shopify_y=54d566ed-7B14-4FEF-26EC-87C1D97873D9"
      }
    })
    .then(res => res.json())
    .then((data) => {
      const bottomSheetPhoneNumber = data?.identified_data?.phone;
      if (bottomSheetCallbackPhone && bottomSheetPhoneNumber) {
        bottomSheetCallbackPhone.value = bottomSheetPhoneNumber;
        checkFormValidity();
      }
    })
    .catch(err => console.error(err));
  }, 
};

let lastFocusedElement = null;

if (bottomSheetCallbackPhone) {
  bottomSheetCallbackPhone.addEventListener('focus', function() {
    if (lastFocusedElement !== bottomSheetCallbackPhone && typeof gaEvent === 'function') {
      gaEvent('acb_phone_initiated', ["", "", "", "", "", ""], false);
    }
    lastFocusedElement = bottomSheetCallbackPhone;
  });
  
  bottomSheetCallbackPhone.addEventListener('input', checkFormValidity);
}

if (bottomSheetCallbackPincode) {
  bottomSheetCallbackPincode.addEventListener('focus', function() {
    if (lastFocusedElement !== bottomSheetCallbackPincode && typeof gaEvent === 'function') {
      gaEvent('acb_pincode_initiated', ["", "", "", "", "", ""], false);
    }
    lastFocusedElement = bottomSheetCallbackPincode;
  });
  
  bottomSheetCallbackPincode.addEventListener('input', checkFormValidity);
}

document.addEventListener('click', function(event) {
  if (event.target !== bottomSheetCallbackPhone && 
      event.target !== bottomSheetCallbackPincode) {
    lastFocusedElement = null;
  }
});